{
  "CHAT_LIST": {
    "LOADING": "Извличане на разговори",
    "LOAD_MORE_CONVERSATIONS": "Зареди още разговори",
    "EOF": "Всички разговори са заредени 🎉",
    "LIST": {
      "404": "Няма активни разговори в тази група."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Разговори",
    "MENTION_HEADING": "Споменавания",
    "UNATTENDED_HEADING": "Unattended",
    "SEARCH": {
      "INPUT": "Търсене на хора, чатове, запазени отговори .."
    },
    "SEARCH_MESSAGES": "Търсене в разговори",
    "SEARCH_INPUT_PLACEHOLDER": "Търсене в разговори...",
    "FILTER_ALL": "Всички",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Мой",
      "unassigned": "Неназначен",
      "all": "Всички"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Вмъкни в отговора",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Отвори",
        "BUY": "Купи"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Отворен"
      },
      "resolved": {
        "TEXT": "Разрешен"
      },
      "pending": {
        "TEXT": "Предстоящ"
      },
      "snoozed": {
        "TEXT": "Отложен"
      },
      "all": {
        "TEXT": "Всички"
      }
    },
    "VIEW_FILTER": "View",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "Статус",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Created",
      "LAST_ACTIVITY": "Last activity:",
      "LAST_CUSTOMER_MESSAGE": "Последно съобщение от клиент:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Последно съобщение от клиент: Най-стари първо"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Последно съобщение от клиент: Най-нови първо"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Приоритет + Създадено на: Най-нови първо"
      },
      "priority_created_at_asc": {
        "TEXT": "Приоритет + Създадено на: Най-стари първо"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Съобщение със снимка"
      },
      "audio": {
        "CONTENT": "Аудио съобщение"
      },
      "video": {
        "CONTENT": "Видео съобщение"
      },
      "file": {
        "CONTENT": "Прикачен файл"
      },
      "location": {
        "CONTENT": "Локация"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "сподели линк"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sort by",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Създаден в",
          "LABEL": "Създаден в"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Получено чрез имейл",
    "VIEW_TWEET_IN_TWITTER": "Виж туита в Twitter",
    "REPLY_TO_TWEET": "Отговори на този туит",
    "LINK_TO_STORY": "Go to instagram story",
    "SENT": "Успено изпратено",
    "READ": "Read successfully",
    "DELIVERED": "Delivered successfully",
    "NO_MESSAGES": "Няма съобщения",
    "NO_CONTENT": "Няма налично съдържание",
    "HIDE_QUOTED_TEXT": "Скриване на цитирания текст",
    "SHOW_QUOTED_TEXT": "Показване на цитирания текст",
    "HIDE_AUTOMATED_MESSAGE": "Скрий съдържанието на автоматичния отговор",
    "SHOW_AUTOMATED_MESSAGE": "Покажи съдържанието на автоматичния отговор",
    "AUTOMATED_MESSAGE": "Автоматичен отговор",
    "MESSAGE_READ": "Read",
    "SENDING": "Sending"
  }
}
